function toggleMoreButton(btn: HTMLButtonElement) {
    const altText = btn.getAttribute('data-alt-text');
    const altIcon = btn.getAttribute('data-alt-icon');
    const label = btn.querySelector('.sgw-link__text-label');
    const icon = btn.querySelector('.sgw-icon > .icon');

    if (!label || !icon) return;

    if (altText && altIcon) {
        const classlist = icon.className.trim().split(/\s+/);
        const lastclass = classlist[classlist.length - 1] || null;
        btn.setAttribute('data-alt-text', label.textContent);
        btn.setAttribute('data-alt-icon', lastclass);
        label.textContent = altText;
        icon.className = `icon icon--24 ${altIcon}`;
    }
}

function loadImage(image: HTMLImageElement): void {
    const imageSrc = image.getAttribute('data-src');
    if (imageSrc) {
        image.setAttribute('src', imageSrc);
        image.removeAttribute('data-src');
    }
}

function toggleCardVisibility(card: HTMLElement, image: HTMLImageElement, makeVisible: boolean): void {
    if (makeVisible) {
        loadImage(image);
        card.dataset.visible = 'true';
        card.classList.remove('sgw-advisor-card--hidden');
    } else {
        card.dataset.visible = 'false';
        card.classList.add('sgw-advisor-card--hidden');
    }
}

const truncatedAdvisorlist = (list: HTMLElement) => {
    const advisorCards = Array.from(list.querySelectorAll<HTMLElement>('.sgw-advisor-card'));
    const showAllLink = list.querySelector('.sgw-advisorlist__show-all') as HTMLButtonElement;

    if (!showAllLink || !advisorCards) return;

    showAllLink.addEventListener('click', (e: Event) => {
        e.preventDefault();

        advisorCards.forEach((card, index) => {
            const advisorImage = card.querySelector<HTMLImageElement>('.sgw-advisor-card__image > img');
            if (!advisorImage) return;

            const isVisible = card.dataset.visible === 'true';
            toggleCardVisibility(card, advisorImage, !isVisible || index < 3);
        });
        advisorCards[0].scrollIntoView({ behavior: 'smooth' });
        advisorCards[0].focus({ preventScroll: true });
        toggleMoreButton(showAllLink);
    });
};
export default function advisorlistMore() {
    document.addEventListener('DOMContentLoaded', () => {
        const lists = document.querySelectorAll<HTMLElement>('.sgw-advisorlist');
        if (lists) {
            lists.forEach((list) => {
                truncatedAdvisorlist(list);
            });
        }
    });
}
